import {Doughnut, mixins} from "vue-chartjs";
import ChartJsPluginDataLabels  from "chartjs-plugin-datalabels";

export default {
  extends: Doughnut,
  mixins:[mixins.reactiveProp],
  props: {
    chartData: {
      type: Array | Object,
      required: true
    },
    chartOptions: {
      type: Array | Object,
      required: false
    }
  },
  mounted() {
    // this.addPlugin(ChartJsPluginDataLabels);
    this.renderChart(this.chartData, this.chartOptions);
  }
}
